import React from "react";
import Sidenav from "../components/Sidenav";
import Box from "@mui/material/Box";
import Navbar from "../components/Navbar";
import QuestionList from "../question/QuestionList";
import "../Dash.css";

export default function Question() {
    return (
        <>
            <div className="bgcolor">
                <Navbar />
                <Box height={70} />
                <Box sx={{ display: "flex" }}>
                    <Sidenav />
                    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                        <QuestionList />
                    </Box>
                </Box>
            </div>
        </>
    );
}
